import { Icon, variables } from '@bitrise/bitkit';
import { VizContext } from '@bitrise/bitviz';
import classnames from 'classnames';
import { motion } from 'framer-motion';
import React, { MouseEvent, useContext, FunctionComponent } from 'react';
import { MinMaxPoint } from './getMinMaxSeries';
import './MinMaxSeries.css';

export const SERIES_HEIGHT = 32;

interface Props extends MinMaxPoint {
  fillBackground: string;
  fillDiamond: string;
  filtered?: boolean;
  onClick?: (event: MouseEvent) => void;
  opacity: number;
  y: number;
}

const MinMaxSeries: FunctionComponent<Props> = (props) => {
  const {
    avg,
    fillBackground,
    fillDiamond,
    max,
    min,
    filtered,
    onClick,
    opacity,
    y,
    ...rest
  } = props;

  const { artboardRight, getX, getY, transition, xDomain, width } = useContext(VizContext);

  const classes = classnames('MinMax__series', {
    'MinMax__series--clickable': onClick,
    'MinMax__series--filtered': filtered,
  });

  const xAvg = getX(avg || xDomain[0]) as number;
  const xMax = (getX(max) || xAvg) as number;
  const xMin = (getX(min) || xAvg) as number;
  const py = getY(y) as number;

  return (
    <motion.g
      {...rest}
      animate={{ opacity }}
      className={classes}
      opacity="0"
      transition={transition}
    >
      <motion.rect
        animate={{
          width,
          y: py - SERIES_HEIGHT / 2,
        }}
        className="MinMax__series-rect"
        fill={fillBackground}
        height={SERIES_HEIGHT}
        initial={{
          width,
          y: py - SERIES_HEIGHT / 2,
        }}
        onClick={onClick}
        transition={transition}
      />

      <g style={{ pointerEvents: 'none' }}>
        <motion.line
          animate={{
            x1: xMin,
            x2: xMax,
            y1: py,
            y2: py,
          }}
          initial={{
            x1: xMin,
            x2: xMax,
            y1: py,
            y2: py,
          }}
          stroke={variables.colorGray5}
          strokeWidth="1"
          transition={transition}
        />
        <motion.g animate={{ x: xAvg, y: py }} initial={{ x: xAvg, y: py }} transition={transition}>
          <polygon fill={fillDiamond} points="0,-6 6,0 0,6 -6,0" />
        </motion.g>
      </g>

      <motion.g
        animate={{ x: artboardRight + 8, y: py - 12 }}
        initial={false}
        style={{ pointerEvents: 'none' }}
      >
        <foreignObject height="24px" width="24px">
          <motion.div animate={{ opacity: filtered ? 1 : 0 }} initial={false}>
            <Icon name="CloseSmall" />
          </motion.div>
        </foreignObject>
      </motion.g>
    </motion.g>
  );
};

export default MinMaxSeries;
